<template>
    <Main>
        <el-row :gutter="20" class="search-table">
            <el-col :span="14" :xs="24" class="mb-2 mb-sm-0">
                <InputSearch v-model="keySearch" @keydown.enter="handleSearchData" @search="handleSearchData" :placeholder="$t('sendMail.valueSearch')"></InputSearch>
            </el-col>
            <el-col :span="10" :xs="24" class="text-right mt-2 mt-sm-0">
                <Button @click="$router.push({ path: '/mail-invite/add' })" type="primary"> <i class="el-icon-plus"></i> {{ $t('button.addNew') }} </Button>
            </el-col>
        </el-row>
        <TableBox :config="config" :reload="isReload" :data-list.sync="dataList" @updateModel="updateModel($event)">
            <template #row="{ row, index, page, perPage }">
                <tr class="row-member">
                    <td :data-title="$t('text.no')">
                        <div class="col-first">{{ index + 1 + (page - 1) * perPage }}</div>
                    </td>
                    <td class="col-surname" :data-title="$t('sendMail.name')">{{ row.name }}</td>
                    <td class="col-name" :data-title="$t('sendMail.title')">{{ row.title }}</td>
                    <td class="col-action__middle" :data-title="$t('sendMail.content')">
                        <div class="text-overflow-ellipsis" v-html="row.content_add"></div>
                    </td>

                    <td :data-title="''" class="col-action">
                        <div class="group-buttons justify-content-center">
                            <Button classes="btn-xs px-2 mr-2" type="info" @click="$router.push({ path: '/mail-invite/edit', query: { id: row.id } })">
                                <el-icon class="el-icon-edit"></el-icon>
                                {{ $t('button.edit') }}
                            </Button>
                            <Button classes="btn-xs px-2" v-loading="isLoadingDelete" @click="handleDeleteConfirm(row)" type="danger">
                                <el-icon class="el-icon-delete"></el-icon>
                                {{ $t('button.delete') }}
                            </Button>
                        </div>
                    </td>
                </tr>
            </template>
        </TableBox>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import TableBox from '@/components/partials/layout/TableBox';
import Button from '@/components/partials/Button';
import InputSearch from '@/components/partials/customs/InputSearch';
import { mapState } from 'vuex';
export default {
    name: 'mailInviteList',
    components: {
        InputSearch,
        TableBox,
        Main,
        Button
    },
    data: function () {
        return {
            config: {
                q: '',
                action: 'mail/list',
                headers: [
                    {
                        label: 'text.no'
                    },
                    {
                        label: 'sendMail.name'
                    },
                    {
                        label: 'sendMail.title'
                    },
                    {
                        label: 'sendMail.content'
                    },
                    {
                        label: ''
                    }
                ],
                dataFilter: {},
                sort: {
                    selected: 'id',
                    order: 'asc'
                }
            },
            isReload: false,
            keySearch: null,
            dataList: [],
            isLoadingDelete: false
        };
    },
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    methods: {
        updateModel(e) {
            this.config.dataFilter = Object.assign({}, e.dataFilter);
            this.config.q = e.search;
            this.keySearch = e.search;
        },
        handleSearchData() {
            this.config.q = this.keySearch ? this.keySearch.toString().trim() : '';
            this.config = Object.assign({}, this.config);
        },
        handleDeleteConfirm(row) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('text.confirmDelete'),
                callback: () => {
                    this.deleteCallback(row);
                }
            });
        },
        deleteCallback(row) {
            this.isLoadingDelete = true;
            let successCallback = (response) => {
                this.isLoadingDelete = false;
                if (response.status === 200) {
                    this.isReload = !this.isReload;
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('text.deleteSuccess')
                    });
                }
            };
            let errorCallback = () => {
                this.isLoadingDelete = false;
                this.isReload = !this.isReload;
            };
            let payload = {
                successCallback,
                errorCallback,
                id: row.id
            };
            this.$store.dispatch('mail/delete', payload);
        }
    }
};
</script>
